module.exports = __webpack_public_path__ + "static/media/compatible-kits.344dfa55.png";